import type { TFunction } from 'i18next';

type FormatListingCountSubtitleParams = {
  loading: boolean;
  count: number;
  label: string;
};

export function formatListingCountSubtitle(
  t: TFunction,
  { loading, count, label }: FormatListingCountSubtitleParams,
): string {
  if (loading && count === 0) return t('LOADING');
  return `${count} ${label}`;
}
